import { CriteriaAnswerTypeCode } from "./enums/CriteriaAnswerTypeCodeEnum"

export class ProductEvaluationSurveyResult {
  productId: number
  productName: string
  productImage: string
  totalScore: any
  submittedAt: any
  criteriaCount: number
  criterias: Criteria[]
}

export class Criteria {
  id: number
  name: string
  order: number
  criteriaWeight: number
  technicalCriteriaAnswerTypeCode: CriteriaAnswerTypeCode
  technicalCriteriaAnswerTypeName: string
  answerValue: string
  starRateEnum: any
  answerWeight: number
  weightedScore: number
  attachmentUrls: AttachmentUrl[]
}

export class AttachmentUrl {
  id: number
  path: string
  name: string
  extention: string
  size: number
}
